module.exports = __webpack_public_path__ + "static/media/cards_management.d0f426b1.svg";